<template>
  <div>
    <h1 class="is-size-3">{{$t('page.taxes')}}</h1>

    <form
      @submit.prevent="onSubmit(country)"
      v-for="(country, i) in $store.getters['options/countries']"
      :key="country.id"
      :data-vv-scope="country.code"
      class="m-t-5"
    >
      <hr v-if="i !== 0" />
      <h2 class="is-size-5 m-b-5 has-text-link">{{country.name}}</h2>
      <div class="columns">
        <div class="column">
          <div class="field is-horizontal">
            <div class="field-label is-normal" style="flex: none;">
              <label class="label">{{$t('form.tax')}}:</label>
            </div>
            <div class="field-body">
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input class="input" v-model="country.tax" type="text" />
                </div>
                <p class="control">
                  <a class="button is-static">%</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label" style="white-space: nowrap;">{{$t('form.tax_for_services')}}:</label>
            </div>
            <div class="field-body">
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input class="input" v-model="country.tax_for_services" type="text" />
                </div>
                <p class="control">
                  <a class="button is-static">%</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-narrow">
          <div class="field">
            <p class="control">
              <button
                type="submit"
                class="button is-primary"
                :class="{ 'is-loading': formLoading === country.code }"
              >{{$t('form.submit')}}</button>
            </p>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formLoading: false
    };
  },

  methods: {
    async onSubmit(country) {
      const validation = await this.$validator.validateAll(country.code);
      if (!validation) return;

      this.formLoading = country.code;

      try {
        const { data } = await this.$api.updateTax({
          id: country.id,
          tax: country.tax,
          tax_for_services: country.tax_for_services
        });
        this.$toast.success(this.$t("message.success"));
      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data);
      }

      this.formLoading = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/nuxt/pages/office/taxes.vue